import { Devtools } from "./devtools"
import { getQueryClient, Provider } from "./provider"

export default {
  getQueryClient,
  Devtools,
  Provider,
}
